import script from "./SignInFields.vue?vue&type=script&setup=true&lang=js"
export * from "./SignInFields.vue?vue&type=script&setup=true&lang=js"

import "./SignInFields.vue?vue&type=style&index=0&id=4b47c2ca&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b47c2ca"]])

export default __exports__